export default {
  payment: 'دفع',
  'payment.title': 'قدم تفاصيل بطاقتك',
  'payment.description':
    'نقبل بطاقات الفيزا والماستركارد الصادرة في الإمارات فقط. يرجى التأكد من أن صلاحية بطاقتك لا تقل عن المدة التي اخترتها.',
  'payment.cardNumber': 'رقم البطاقة',
  'payment.expiryDate': 'MM/YY',
  'payment.cvvNumber': 'CVV',
  'payment.cardRequired': 'الرجاء إدخال بطاقة',
  'payment.expiryDateRequired': 'الرجاء إدخال تاريخ انتهاء الصلاحية',
  'payment.cvvRequired': 'الرجاء إدخال رمز السيرة الذاتية',
  'payment.security':
    'نحن نستخدم بروتوكولات أمان ثلاثية الأبعاد لنوفر لك قدرًا أكبر من الأمان والحماية من الاحتيال.',
  'payment.cardHolder': 'Card holder',
};
